// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wraper":"wraper_QdGaQ","trip_img":"trip_img_uuwvs","trip_table":"trip_table_MfrTX","trip_table_wrap":"trip_table_wrap_rEwfc","ui_mask":"ui_mask_67PvJ"};